import { render, staticRenderFns } from "./delivered-add-or-update.vue?vue&type=template&id=798794d4&scoped=true"
import script from "./delivered-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivered-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./delivered-add-or-update.vue?vue&type=style&index=0&id=798794d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798794d4",
  null
  
)

export default component.exports